import { render, staticRenderFns } from "./news-detail.vue?vue&type=template&id=54a1d7d5&scoped=true"
import script from "./news-detail.vue?vue&type=script&lang=js"
export * from "./news-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a1d7d5",
  null
  
)

export default component.exports